
import React from "react";
import { Program } from "@/services/db";
import { BookOpenCheck } from "lucide-react";
import ProgramItem from "./ProgramItem";

interface ProgramsListProps {
  programs: Program[];
}

const ProgramsList = ({ programs }: ProgramsListProps) => {
  // Calculate overall progress across all programs
  const calculateOverallProgress = () => {
    if (!programs || programs.length === 0) return { completed: 0, total: 0, percentage: 0 };
    
    let totalCompleted = 0;
    let totalPrograms = programs.length;
    
    programs.forEach(program => {
      const enrolledDate = new Date(program.enrolledAt);
      const completionDate = new Date(program.completionDate);
      const today = new Date();
      
      const totalDays = Math.abs(completionDate.getTime() - enrolledDate.getTime()) / (1000 * 60 * 60 * 24);
      const daysElapsed = Math.abs(today.getTime() - enrolledDate.getTime()) / (1000 * 60 * 60 * 24);
      
      // Consider program completed if current date is past completion date
      if (today >= completionDate) {
        totalCompleted += 1;
      }
    });
    
    const percentage = totalPrograms > 0 ? Math.round((totalCompleted / totalPrograms) * 100) : 0;
    
    return {
      completed: totalCompleted,
      total: totalPrograms,
      percentage
    };
  };

  const overallProgress = calculateOverallProgress();

  return (
    <div className="p-2 space-y-1.5">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-1.5">
          <BookOpenCheck className="h-2.5 w-2.5 text-nalc-teal" />
          <h4 className="font-medium text-xs">Program Details</h4>
        </div>
        <div className="text-xs font-medium text-nalc-teal">
          {overallProgress.completed}/{overallProgress.total} Complete
        </div>
      </div>
      
      {/* Overall Progress Bar */}
      <div className="w-full bg-gray-200 dark:bg-gray-700 rounded-full h-1 mb-2">
        <div 
          className="h-1 rounded-full bg-nalc-teal transition-all duration-300" 
          style={{ width: `${overallProgress.percentage}%` }}
        />
      </div>
      
      <div className="space-y-1 max-h-24 overflow-y-auto pr-1 scrollbar-thin">
        {programs.map((program, index) => (
          <ProgramItem key={index} program={program} index={index} />
        ))}
      </div>
    </div>
  );
};

export default ProgramsList;
